import { ICommonListResourceServiceQueryData } from './common-base-list-resource.service';
import { COMMON_DEFAULT_PAGE_SIZE } from '@CaseOne/Common/constants/common_default_page_size.constant';

export const COMMON_LIST_RESOURCE_DEFAULT_REQUEST_PARAMS: ICommonListResourceServiceQueryData = {
	Page: 1,
	PageSize: COMMON_DEFAULT_PAGE_SIZE,
};
